import React from 'react'
import { TextFieldStyles } from 'components/Form/Styled';
import { CustomAutoCompleteStyles } from './Style'

const CustomAutoComplete = (props) => {
    const { readOnlyInput, placeholder = "בחר", showBlurred, width, hasValue, ...rest } = props;
    // MUI מכניס את הצ'יפים/בחירות לתוך InputProps.startAdornment
    const hasSelections = props.InputProps?.startAdornment && props.InputProps.startAdornment.length > 0;

    return (
        <CustomAutoCompleteStyles width={width}>
            <TextFieldStyles
                {...rest}
                showBlurred={showBlurred}
                variant="outlined"
                size="small"
                color="thirdly"
                // הפתרון ללייבל הקופץ:
                label="" // משאירים ריק כי יש לך לייבל חיצוני (מעל השדה)
                placeholder={hasValue ? "" : placeholder}
                inputProps={{
                    ...rest.inputProps,
                    readOnly: readOnlyInput,
                }}
                InputLabelProps={{
                    ...rest.InputLabelProps,
                    shrink: false, // מונע את האנימציה של "קפיצת" הלייבל למעלה
                }}
            />
        </CustomAutoCompleteStyles>
    )
}

export default CustomAutoComplete